import React, { useEffect, useRef } from 'react';
import { SHORT_PLAIN_TEXT_VALIDATION_MESSAGE } from '../../../constans/common-constants';
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize';
import './auto-textarea.scss';
import { observer } from 'mobx-react';

interface IAutoTextAreaProps extends TextareaAutosizeProps {
  className: string;
  classNameWrapper: string;
  hasError: boolean;
  enableAutoFocus: boolean;
}

const AutoTextArea = ({ hasError, className, classNameWrapper, enableAutoFocus, ...rest }: Partial<IAutoTextAreaProps>): JSX.Element => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if(!enableAutoFocus) return;

    if(textareaRef && textareaRef.current) {
      const textArea = textareaRef.current;
      const textAreaLength = textArea.value.length;
      textArea.focus();
      textArea.setSelectionRange(textAreaLength, textAreaLength);
    }
  }, []);

  return (
    <div className={`auto-textarea-wrapper ${classNameWrapper}`}>
      <TextareaAutosize {...rest} className={className} ref={textareaRef}/>
      {hasError && (
        <span>{SHORT_PLAIN_TEXT_VALIDATION_MESSAGE}</span>
      )}
    </div>
  );
};

export default observer(AutoTextArea);
